<template>
  <div class="book">
    <div class="container btnP searchDV text-center pt-2">
        
      <button class="btn btn-info btnP" @click="prt()">طباعة</button>
    </div>

    <div class="page1" v-for="itm in lng" :key="itm">
      <div class="subpage">
   <header class="row">
          <div class="col-4 pt-4">
            شركة الصافنات للنقل
          </div>
          <div class="col-4">
            <p class="text-center">بسم الله الرحمن الرحيم</p>
            <h3 class="text-center">عقد إتفاق مع سائق</h3>
            <p class="text-center"><span>رقم العقد  /</span>
            <span>{{items.id}}</span>


            </p>
          </div>
          <div class="col-4 text-left">
            <img src="../../../public/static/img/logo.png" alt="" />
            <p class="text-left"><span>الجوال / </span> <span> 0505575095</span></p>
            <p class="text-left"><span>الهاتف / </span> <span> 2422839</span></p>
             
          </div>
        </header>
        <div class="bd">
      <div>
          <div>
<span>بعون الله تعالى تم الاتفاق بين كلا من :</span>
          </div>
           <div>
<span>1- الطرف الاول : الصافنات للنقل الجامعي</span>
          </div>
           <div>
<span>ويمثلها مدير عام المؤسسة والمشرف على مكتب الحافلات شجاع مبارك الشجاع</span>
          </div>
          <div class="col-6">
<span>2- الطرف الثانى:</span><span>{{items.Fname}}   &nbsp; {{items.Sname}} &nbsp; {{items.Tname}} &nbsp; {{items.Ffname}}</span>
          </div>
         <div class="col-6">
<span>رقم البطاقة / </span><span>{{items.NationalId}}</span>
         </div>
       <div class="col-12">
<span>وعنوانه / </span><span>{{items.Address}}</span>
         </div>
                <div class="col-12">
<span>جوال :</span><span>{{items.Mob}}</span>
          </div>
        
           <div>
<span>أن يعمل الطرف الثاني لدى الأول بمهنة سائق لنقل المعلمات وفق الشروط التالية :</span>
         </div>
      </div>
        <div>
          <span>1)</span>  <span>يدفع الطرف الأول للطرف الثانى مبلغ شهري وقدره</span>
        <span>(</span><span>{{items.Salary}}</span><span>ريال</span><span>).</span>
     <span>مع محرمه.</span>
      </div>
      
        <div>
        <span>2)</span>
        <span>فترة العمل هى فقط أوقال الدراسة والتي يخرج فيها المعلمات الى مدارسهن أما إجازة العيد أو الفصيلة أو الصيفية فهى إجازات غير محسوبة من الراتب , وأيام العودة فقط تحسب الأيام التى يخرج بها المعلمات .</span>
      </div>
<div>
        <span>3)</span>
        <span>وقت العمل هو يومياً ويجب عليه إنجاز العمل المطلوب منه الذى يحدده مدير المكتب .</span>
      </div>
      <div>
        <span>4)</span>
        <span>المهام التي يجب على الطرف الثانى </span>
        <span>(السائق)</span>
        <span>القيام بها فى ما يلي :</span>
      </div>
      <h5>اولاً : إتجاه مكتب الكرف الأول (مكتب الحافلات):</h5>
      <div>
        <span> - </span>
        <span>العمل وفق ما يطلبه مجير مكتب الحافلات .</span>
      </div>
       <div>
        <span> - </span>
        <span>حفظ أسرار العمل .</span>
      </div>
       <h5>ثانياً : إتجاه المعلمات:</h5>
      <div>
        <span> - </span>
        <span>تجميع المعلمات صباحاً فى الوقت الذى يحدده مدير مكتب الحافلات .</span>
      </div>
       <div>
        <span> - </span>
        <span>إيصال المعلمات الي المدارس في المناطق التي يحددها مدير مكتب الحافلات .</span>
      </div>
      <div>
        <span> - </span>
        <span>حفظ أسرار المعلمات من منازلهن أو أرقامهن أو غيرها وعدم إعطاءها لأحد إلا بإذن مدير مكتب الحافلات .</span>
      </div>
      <div>
        <span> - </span>
        <span>إنتظار المعلمات عند مدارسهن وإعادتهن إلي منازلهن كالمعتاد .</span>
      </div>
      <div>
        <span> - </span>
        <span>إحترام المعلمات وعدم رفع الصوت عليهن أو مخاطبتهن بأسلوب غير لائق .</span>
      </div>
    <div>
        <span> - </span>
        <span>كل تعليمات إضافية يصدرها مدير مكتب الحافلات أو من ينوب عنه لمصلحة العمل  .</span>
      </div>
 <h5>ثالثاً : إتجاه السيارة:</h5>
      <div>
        <span> - </span>
        <span>عند إستلام سيارته يقوم بفحصها بالكامل واي عيب أو نقص بالسيارة من عفريتة أو الإطار احتياطى بعد إستلامه للسيارة فإنه هو المسئول الأول عن هذا ويتحمل قيمة النقص أو إصلاح العيب .</span>
      </div>
       <div>
        <span> - </span>
        <span>فحص زيوت محركات السيارة (جير , ماكينة) وزيوت الفرامل والدركسون وغيرها يومياً وكذلك الماء وأي عطل ناتج عن إهمال ما ذكر يتحمله السائق .</span>
      </div>
      <div>
        <span> - </span>
        <span>عدم تحاوز السرعة المحددة بالطريق .</span>
      </div>
      <div>
        <span> - </span>
        <span>توقيفها بأماكن مناسبة بعيدة عن الزحام وعبث الأطفال .</span>
      </div>
      <div>
        <span> - </span>
        <span>عدم استعمالها فى الامور الخاصة بغير العمل سواء داخل الرياض أو خارجها .</span>
      </div>
    <div>
        <span> - </span>
        <span>مراقبة السيارة مراقبة جيدة والتغييرات التي تطرأ عليها من أصوات وغير ذلك وعدم إهمال الأعطال لتتفاقم المشكلة وعليه إخبار مدير المكتب بأى عطل والسائق هو المسئول عن صيانة سيارته</span>
     <span> وإحضار القطع وتسليمها للورشة وإستلام السيارة وغير ذلك , بالتعاون مع مشرف الصيانة. </span>
      </div>
     <div>
        <span> - </span>
        <span>السائق مسئول عن الحواث التي قد يتعرض لها (لا سمح الله) كما يقرره المرور ويجب عليه أخذ الحيطة والحذر وذلك بالنوم مبكراً وعدم السهر ومراقبة الطريق وإطارات السيارات وعند وجود</span>
     <span> أى خلل بإطار ما , يجب عليه إخبار مدير المكتب لتغيير الإطار المتضرر والإ فالمسئولية تكون على السائق . </span>
      </div>
        </div>
                <footer class="row footer">
          <div class="col-4">
            <span>رقم الصفحة </span>
            <span>1</span>
            <span> | </span>
            <span> 2 </span>
          </div>
          <div class="col-4 "></div>
          <div class="col-4">
            <span>التاريخ</span>
            <span> / </span>
            <span>{{dt}} </span>
          </div>
        </footer>
      </div>
    </div>
      <div class="page1" v-for="itm in lng" :key="itm">
      <div class="subpage">
   <header class="row">
          <div class="col-4 pt-4">
            شركة الصافنات للنقل
          </div>
          <div class="col-4">
         
          </div>
          <div class="col-4 text-left">
            <img src="../../../public/static/img/logo.png" alt="" />
          </div>
        </header>

           <div class="bd mt-0">
              <h5>رابعاً : إتجاه زملائه السائقين:</h5>
  <div>
        <span> - </span>
        <span>الاحترام المتبادل بين السائقين والتعاون فيما بينهم .</span>
      </div>
  <div>
        <span> - </span>
        <span>نصح زملائه عند أخطاءهم كالسرعة وغيرها .</span>
      </div>
  <div>
        <span> - </span>
        <span>عند حدوث مشكلة لأحدهم فى الخط فعليه مساعدته بعد إعطاء خبر لمدير المكتب وبما لا يضر المعلمات اللاتي معه.</span>
      </div>
<h5>خامساً : شروط عامة آخرى:</h5>
  <div>
        <span> - </span>
        <span>يدفع السائق مبلغ شهري لمكتب الطرف الأول وقدره (500 ريال) كتأمين على السيارة التي بعهدته ويجمع له حتى نهاية الفصل الدراسي ويعاد له بعد تسليمه للسيارة كما استلمها ,  .</span>
    <span> ويحق لمكتب الطرف الأول الأخذ من هذا المبلغ نتيجة تعرض السيارة للحوادث أو الحكات أو غيرها . </span>
      </div>
  <div>
        <span> - </span>
        <span>فى حال تغيب السائق عن العمل بدون عذر فإنه يخصم عليه ما يخصمه المعلمات على مكتب الحافلات ولقبول عذره يجب </span>
        <span> تأمين سائق بديل من طرفه يوافق علية مدير مكتب الحافلات أو سائق من مكتب الحافلات يراه المدير مناسباً بحيث يقوم الطرف الثاني (السائق) بتجميع المعلمات وتوزيعهن للسائق الآخر  </span>
    <span> ويخصم على الطرف الثانى نصف يومية وتعطى للسائق الآخر بدل خروج عنه . </span>
      </div>
  <div>
        <span> - </span>
        <span>يحق لمدير مكتب الحافلات بالطرف الأول الطلب من الطرف الثانى (السائق) بتوزيع أو تجميع أي معلمات غير معلماته أو نقله من خطه الى خط آخر وليس للطرف الثانى الاعتراض على هذا . .</span>
      </div>
 <div>
        <span> - </span>
<span>لمدير مكتب الحافلات الحق بفصل أي سائق يخالف الأنظمة والتعليمات بعد الرجوع للطرف الأول وتغيرمه بما يرونه مناسباً .</span>
      </div>
 <div>
        <span> - </span>
<span>للطرف الثاني السائق التوقف عن العمل بعد إبلاغ مدير مكتب الطرف الأول خطياً بخمسة عشر يوماً لإن وجد سائق بديل وفي حال توقفه فجأة دون إنذار مسبق فللطرف الأول الحق بتغريم الطرف الثاني بمبلغ وقدره .</span>
    <span> (ثلاثة آلاف ريال لاغير) . </span>
      </div>
             <div class="row mt-3">
     
             <div class="col-12 pb-3">
                 <span>....................................................................................................</span>
                 <span>والله ولى التوفيق</span>
                  <span>....................................................................................................</span>
          </div>
          <div class="col-4">
<div>الطرف الاول</div>
<div>الصافنات للنقل الجامعى</div>
          </div>
               <div class="col-4">
  <p class="text-center"> الختم</p>
          </div>
               <div class="col-4">
<div>الطرف الثانى</div>

<div><span>{{items.Sname}} &nbsp; {{items.Tname}} &nbsp; {{items.Ffname}}</span></div>
          </div>
      </div>
           </div>
                <footer class="row footer">
          <div class="col-4">
            <span>رقم الصفحة </span>
            <span>2</span>
            <span> | </span>
            <span> 2 </span>
          </div>
          <div class="col-4 "></div>
          <div class="col-4">
            <span>التاريخ</span>
            <span> / </span>
            <span>{{dt}} </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import reportsLayout from "../../layouts/reportsLayout.vue";

export default {
  name: "driverR",
  data() {
    return {
        items:'',
      lng: 0,
      datalng: 0,
      cunt: 10,
      indx: 0,
      kwd: 0,
      dt:'',
      inx:1,
      sst:'',
      ppt:'',
      services:'',
      duration:'',
      loadsub:[],
      srv:'',
      dur:'',
      colDist:''      

    };
  },
   props:['id'],
  computed: {
    ...mapGetters({
      emp: "empMod/GET_ALLDATA",
      colg: "collagesMod/GET_ALLDATA",
      distc: "GET_DISTRICT",
      servic: "GET_SERVICE",
      loadDuration: "GET_DURATION"
    }),
  },
  created() {
    this.$emit("update:layout", reportsLayout);
     this.loadData();
    this.reportLoad();
  },
  methods: {
   loadData(){
      this.items = this.emp.find((t)=> t.id == this.id);
      // var tdi = this.items.transfareType_id;
      // var cdi = this.items.contractType_id;
      // var collg = this.items.Collage_id;
      // this.srv = this.servic.find((t)=>t.id == tdi);
      // this.dur = this.loadDuration.find((t)=>t.id == cdi);
      // var colD = this.colg.find((t)=>t.id == collg);
      // this.colDist =  this.distc.find((t)=>t.id == colD.District);
       const event = new Date();
       const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        }
     this.dt = event.toLocaleDateString('ar-SA', options);
   },
    reportLoad() {
      if (this.loadsub != null) {
        this.indx = this.loadsub.length - 1;
        var lln = Math.floor(this.loadsub.length / this.cunt);
        if (lln < 1) {
          this.cunt = this.loadsub.length ;
          this.lng = 1;
        } else {
          this.lng = Math.ceil(this.loadsub.length / this.cunt);
          var ss = this.cunt * lln;
          this.kwd = this.loadsub.length - ss;
        }
       
        //window.print();
      }
    }, addnum: function(indx, itm) {
      
     this.inx += 1; 

    this.indx = this.indx - 1 
    
      if (itm == this.lng) {

        if (this.kwd > 1) {
            
          if (this.indx == this.kwd - 1) {
           
           this.cunt = this.indx;
          }

        } else if(this.kwd == 1) {

          if (this.indx == 1) {
            this.cunt = 1;
          }
          
        }
      }
      /* var chk = this.loadsub[indx].id;
      if(chk == 'undefind'){
      this.indx = chkV;
      } */
    },
    prt() {
      window.print();
    },
    loadDate(){
      const event = new Date();
       const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        }
     this.dt = event.toLocaleDateString('ar-SA', options);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../public/static/css/print.css";
.searchDV {
  height: 50px;
  width: 790px;
  background-color: white;
}
.bd {
  height: 940px;
  margin-top: -70px;
}
.pad{
    padding-right: 250px;
}
thead{
 background-color: #d4d4d4; 
}

.col-12{
    margin-top: 5px;
}
.footer{
    margin-top: -35px;
}
h5{
  margin: 5px 0;
  text-decoration: underline;
  font-weight: bold;
}
div{
  margin-bottom: 2px;
}
</style>
